(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  function initIngredientsCarousel(root) {
    const track = root.querySelector('[data-track]');
    const arrows = root.querySelectorAll('.ingredients-carousel__arrow');
    if (!track) return;

    function scrollByCard(direction) {
      const item = track.querySelector('.ingredients-carousel__item');
      if (!item) return;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      const amount = item.getBoundingClientRect().width + gap;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = track.scrollWidth - track.clientWidth - 1;
      arrows.forEach((btn) => {
        if (btn.dataset.dir === 'prev') {
          btn.disabled = track.scrollLeft <= 0;
        } else {
          btn.disabled = track.scrollLeft >= max;
        }
      });
    }

    arrows.forEach((btn) => {
      btn.addEventListener('click', () => scrollByCard(btn.dataset.dir === 'next' ? 1 : -1));
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  document.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);

  // Réattache le comportement lors de l'ajout/déplacement de la section dans l'éditeur de thème.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-text-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function whenSplideReady(cb) {
      if (window.Splide) return cb();
      var tries = 0;
      var timer = setInterval(function () {
        if (window.Splide || tries++ > 60) {
          clearInterval(timer);
          if (window.Splide) cb();
        }
      }, 50);
    }

    function initLogoTextCarousel(root) {
      if (root.dataset.ltcInit) return;
      root.dataset.ltcInit = 'true';

      var sliderEl = root.querySelector('.logo-text-carousel__slider');
      var textWrap = root.querySelector('.logo-text-carousel__text');
      var quoteEl = root.querySelector('.logo-text-carousel__quote');
      var sourceEl = root.querySelector('.logo-text-carousel__source');
      if (!sliderEl) return;

      var options = {};
      try {
        options = JSON.parse(root.dataset.splideOptions || '{}');
      } catch (e) {
        options = {};
      }

      var splide = new Splide(sliderEl, options);

      function updateText(index) {
        var slides = splide.Components.Elements.slides;
        var slide = slides[index];
        if (!slide || !textWrap) return;
        var quote = slide.getAttribute('data-quote') || '';
        var source = slide.getAttribute('data-source') || '';
        textWrap.classList.add('is-changing');
        setTimeout(function () {
          if (quoteEl) quoteEl.textContent = quote;
          if (sourceEl) sourceEl.textContent = source;
          textWrap.classList.remove('is-changing');
        }, 200);
      }

      splide.on('move', function (newIndex) {
        updateText(newIndex);
      });
      splide.on('mounted', function () {
        updateText(splide.index);
      });
      splide.mount();
    }

    function initAll() {
      whenSplideReady(function () {
        document.querySelectorAll('.logo-text-carousel').forEach(initLogoTextCarousel);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
